import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


import './Carrusel.css';

const Carrusel = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const totalSlides = 4;

    // Avance automático cada 5 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            handleNext();
        }, 5000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
    };
    return (
        <div className="carousel-container">
            {/* Flechas de navegación manual */}
            <button className="nav-btn prev-btn" onClick={handlePrev} aria-label="Anterior">
                &#10094;
            </button>
            <button className="nav-btn next-btn" onClick={handleNext} aria-label="Siguiente">
                &#10095;
            </button>

            {/* Track que se desplaza usando transform inline */}
            <div
                className="carousel-track"
                style={{ transform: `translateX(-${currentIndex * 33.333}%)` }}
            >
                {/* Diapositiva 1 */}
                <div className="carousel-slide slide-1">
                    <div className="slide-content-left">
                        <p className="text-overlay">Formación que transforma vidas</p>
                        <h1 className="main-title">
                            Educación con calidad, compromiso social y respaldo institucional.
                        </h1>
                        <div className="button-group">
                            <Link className="btn btn-red" to={`/formaciontecnicolaboral`}>
                                Ver programas
                            </Link>
                            <a href="https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99" className="btn btn-blue">Inscríbete ahora</a>

                        </div>
                    </div>
                    <div className="slide-image-overlay"></div>
                </div>

                {/* Diapositiva 2 */}
                <div className="carousel-slide slide-2">
                    <div className="slide-content-left">
                        <p className="text-overlay">Nuevas Oportunidades</p>
                        <h1 className="main-title">Aprende nuevas habilidades con nuestros cursos.</h1>
                        <div className="button-group">
                            <Link className="btn btn-red" to={`/formaciontecnicolaboral`}>
                                Ver programas
                            </Link>
                            <a href="https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99" className="btn btn-blue">Inscríbete ahora</a>

                        </div>
                    </div>
                    <div className="slide-image-overlay2"></div>
                </div>

                {/* Diapositiva 3 */}
                <div className="carousel-slide slide-3">
                    <div className="slide-content-left">
                        <p className="text-overlay">Inscríbete Hoy</p>
                        <h1 className="main-title">Únete a nuestra comunidad educativa.</h1>
                        <div className="button-group">
                            <Link className="btn btn-red" to={`/formaciontecnicolaboral`}>
                                Ver programas
                            </Link>
                            <a href="https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99" className="btn btn-blue">Inscríbete ahora</a>

                        </div>
                    </div>
                    <div className="slide-image-overlay3"></div>
                </div>

                {/* Diapositiva 4 */}
                <div className="carousel-slide slide-4">
                    <div className="slide-content-left">
                        <p className="text-overlay">Inscríbete Hoy</p>
                        <h1 className="main-title">Únete a nuestra comunidad educativa.</h1>
                        <div className="button-group">
                            <Link className="btn btn-red" to={`/formaciontecnicolaboral`}>
                                Ver programas
                            </Link>
                            <a href="https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99" className="btn btn-blue">Inscríbete ahora</a>

                        </div>
                    </div>
                    <div className="slide-image-overlay4"></div>
                </div>
            </div>

            {/* Indicadores opcionales (puntos) */}
            <div className="carousel-indicators">
                {[...Array(totalSlides)].map((_, index) => (
                    <span
                        key={index}
                        className={`indicator ${currentIndex === index ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>




    );
}

export default Carrusel;
